// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5b473115","855":"60d5fafd"}[chunkId] + ".chunk.js";
};